import React from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";
import { Button } from "./index";
import { trackShare } from "../../utility/analytics.utils";

interface CopyLinkButtonProps {
  iconOnly?: boolean;
  storyId?: string;
  chapterId?: string;
}

const CopyLinkButton = ({ iconOnly = false, storyId, chapterId }: CopyLinkButtonProps) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      toast.success("Story link copied successfully");
      
      // Track copy link action
      const contentType = chapterId ? "chapter" : "story";
      const contentId = chapterId || storyId || "";
      if (contentId) {
        trackShare(contentType as "story" | "chapter", contentId, "copy_link");
      }
    } catch (err) {
      console.error("Copy failed:", err);
      toast.error("Failed to copy story URL. Please try again");
    }
  };

  if (iconOnly) {
    return (
      <Button
        variant="icon"
        onClick={handleCopy}
        sx={{ minWidth: "auto", width: 40, height: 40, p: 0 }}
      >
        <ContentCopyIcon sx={{ fontSize: 20 }} />
      </Button>
    );
  }

  return (
    <Button variant="outlined" onClick={handleCopy} startIcon={<ContentCopyIcon />}>
      Copy Link
    </Button>
  );
};

export default CopyLinkButton;
